import { render, staticRenderFns } from "./GenericText.vue?vue&type=template&id=8a8d62ec&scoped=true"
import script from "./GenericText.vue?vue&type=script&lang=js"
export * from "./GenericText.vue?vue&type=script&lang=js"
import style0 from "./GenericText.vue?vue&type=style&index=0&id=8a8d62ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8d62ec",
  null
  
)

export default component.exports